var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"cont"},[_vm._v(" Copyright (C) 2022 Customaid:LLC All Rights Reserved. ")])])
}]

export { render, staticRenderFns }